import axios from 'axios'

const getSkin = (skinId: string) => {
	return axios
		.request({
			method: 'get',
			url: `/skins/${skinId}/data.json`,
		})
		.then(function (response) {
			return response.data
		})
}

export default {
	getSkin,
}
